import {
  InsertInvoiceRequest,
  InsertInvoiceResponse,
  GetInvoiceResponse,
  GetInvoiceListResponse,
} from '@/model/invoiceModel';
import { ResultModel } from '@/model/viewModel';
import { ApiResult, post } from '@/utils/api';

export const insertInvoice = (data: InsertInvoiceRequest) =>
  post<InsertInvoiceResponse>('/order/invoice/insert', data);

export const editInvoice = (data: any): Promise<ApiResult<any>> =>
  post<any>('/order/invoice/edit', data);

export const deleteInvoice = (data: any): Promise<ApiResult<any>> =>
  post<any>('/order/invoice/delete', data);

export const getInvoiceList = (data: any) =>
  post<ResultModel<GetInvoiceListResponse>>('/order/invoice/select', data);

export const getInvoice = (data: any) => post<GetInvoiceResponse>('/order/invoice/selectOne', data);
